/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, May 2020
 */
const { hasOwnProperty } = Object.prototype;

/**
 * Loops through all own properties of an object.
 *
 * @param object Object to iterate.
 * @param iterator A function that will be called for each own property on the object.
 */
export function forOwn<T, K extends string | number | symbol>(
    object: Record<K, T>,
    iterator: (value: T, key: K) => void
): void {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in object) {
        if (hasOwnProperty.call(object, key)) {
            iterator(object[key], key);
        }
    }
}



// WEBPACK FOOTER //
// ./src/packages/core/lib/objects/forOwn.ts